// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__y53Ij","row":"Search_row__QjF0w","col":"Search_col__Q4sNT"};